import { DesignData, MediaElement } from 'editor/src/store/design/types';

function getFirstPersonalizableElement(data: DesignData): MediaElement | undefined {
  return data.spreads
    .flatMap((spread) => spread.pages.flatMap((page) => page.groups.media ?? []))
    .find((media) => !media.personalizationLocked && !media.hidden);
}

export default getFirstPersonalizableElement;
